var LANG;
(function (LANG) {
    LANG["FR"] = "fr";
})(LANG || (LANG = {}));
var FORMAT;
(function (FORMAT) {
    FORMAT["LONG"] = "long";
    FORMAT["SHORT"] = "short";
    FORMAT["NUMERIC"] = "numeric";
})(FORMAT || (FORMAT = {}));
var Moment = /** @class */ (function () {
    function Moment() {
    }
    Moment.timestampToISOString = function (timestamp) {
        var date = new Date(timestamp * 1000);
        return this.toISOString(date);
    };
    /** Set **/
    Moment.setToBeginOfTheDay = function (date) {
        date.setHours(0, 0, 0, 0);
        return date;
    };
    Moment.setToEndOfTheDay = function (date) {
        date.setHours(23, 59, 59, 999);
        return date;
    };
    /** Add **/
    Moment.addToDate = function (date, add) {
        if (!(date instanceof Date)) {
            date = new Date(date);
        }
        if (add.years !== undefined) {
            date = this.addYears(date, add.years);
        }
        if (add.months !== undefined) {
            date = this.addMonths(date, add.months);
        }
        if (add.days !== undefined) {
            date = this.addDays(date, add.days);
        }
        return date;
    };
    Moment.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    Moment.addMonths = function (date, months) {
        date.setMonth(date.getMonth() + months);
        return date;
    };
    Moment.addYears = function (date, years) {
        date.setFullYear(date.getFullYear() + years);
        return date;
    };
    Moment.toLocaleDateStringSupportsLocales = function (options) {
        try {
            if (options === undefined) {
                options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            }
            new Date().toLocaleDateString('fr-FR', options);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    Moment.displayDate = function (options) {
        return options === undefined || options.displayDate === undefined || options.displayDate;
    };
    Moment.displayISO = function (options) {
        return options === undefined || options.ISOFormat !== undefined;
    };
    Moment.displayHour = function (options) {
        return options === undefined || options.displayHour === undefined || options.displayHour;
    };
    Moment.getLang = function (options) {
        if (options === undefined || options.lang === undefined) {
            return LANG.FR;
        }
        else {
            return options.lang;
        }
    };
    Moment.format = function (date, options) {
        var event = date instanceof Date ? date : (date ? new Date(Moment.formatDateForSafari(date)) : new Date());
        if (this.displayISO(options) || !this.toLocaleDateStringSupportsLocales()) {
            var date_1 = this.toISOString(event);
            var hours = this.getHoursFromDate(event);
            return ''
                + (this.displayDate(options) ? date_1 : '')
                + (this.displayDate(options) && this.displayHour(options) ? ' ' : '')
                + (this.displayHour(options) ? hours : '');
        }
        else {
            return ''
                + (this.displayDate(options) ? event.toLocaleDateString(this.getLang(options), options) : '')
                + (this.displayDate(options) && this.displayHour(options) ? ' ' : '')
                + (this.displayHour(options) ? this.getHoursFromDate(event) : '');
        }
    };
    Moment.getDateFromNow = function (options) {
        var event = new Date().getTime();
        var daysInMilliseconde = options.numberOfDay ? options.numberOfDay * 24 * 60 * 60 * 1000 : 0;
        var hoursInMilliseconde = options.numberOfHour ? options.numberOfHour * 60 * 60 * 1000 : 0;
        var minutesInMilliseconde = options.numberOfMinute ? options.numberOfMinute * 60 * 1000 : 0;
        return new Date(event
            + daysInMilliseconde
            + hoursInMilliseconde
            + minutesInMilliseconde);
    };
    Moment.compareDate = function (event1, event2, asc) {
        if (asc === void 0) { asc = true; }
        if (event1.getTime() === event2.getTime())
            return 0;
        else if (event1 > event2)
            return asc ? -1 : 1;
        else
            return asc ? 1 : -1;
    };
    Moment.getHoursFromDate = function (date) {
        var hh = date.getHours();
        var mm = date.getMinutes();
        if (hh < 10) {
            hh = '0' + hh;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return hh + ':' + mm;
    };
    Moment.toISOString = function (date, withHours) {
        if (withHours === void 0) { withHours = true; }
        function formatNumber(value) {
            if (value < 10) {
                return '0' + value;
            }
            else {
                return value;
            }
        }
        var sss = date.getMilliseconds();
        var ss = date.getSeconds();
        var mm = date.getMinutes();
        var HH = date.getHours();
        var DD = date.getDate();
        var MM = date.getMonth() + 1; //January is 0!
        var YYYY = date.getFullYear();
        if (sss < 10) {
            sss = '00' + sss;
        }
        else if (sss < 100) {
            sss = formatNumber(sss);
        }
        ss = formatNumber(ss);
        mm = formatNumber(mm);
        HH = formatNumber(HH);
        DD = formatNumber(DD);
        MM = formatNumber(MM);
        return YYYY + '-' + MM + '-' + DD + (withHours ? 'T' + HH + ':' + mm + ':' + ss + 'Z' : '');
    };
    /** TITRE **/
    Moment._getTimeFromNow = function (date) {
        return new Date().getTime() - date.getTime();
    };
    Moment.getTimeFromNow = function (date) {
        var timeInMill = this._getTimeFromNow(date);
        var timeInSec = Math.trunc(timeInMill / 1000);
        var timeInMin = Math.trunc(timeInSec / 60);
        var timeInHour = Math.trunc(timeInMin / 60);
        var timeInDay = Math.trunc(timeInHour / 24);
        var timeInMonth = Math.trunc(timeInDay / 30);
        var timeInYear = Math.trunc(timeInMonth / 365);
        if (timeInSec < 60) {
            return "Il y a " + timeInSec + " seconde" + (timeInSec > 1 ? 's' : '');
        }
        else if (timeInMin < 60) {
            return "Il y a " + timeInMin + " minute" + (timeInMin > 1 ? 's' : '');
        }
        else if (timeInHour < 24) {
            return "Il y a " + timeInHour + " heure" + (timeInHour > 1 ? 's' : '');
        }
        else if (timeInDay < 30) {
            return "Il y a " + timeInDay + " jour" + (timeInDay > 1 ? 's' : '');
        }
        else if (timeInMonth < 12) {
            return "Il y a " + timeInMonth + " mois";
        }
        else {
            return "Il y a " + timeInYear + " année" + (timeInYear > 1 ? 's' : '');
        }
    };
    /** Validation **/
    Moment.isCorrectFormat = function (date) {
        return !isNaN(Date.parse(date));
    };
    /** UTC **/
    Moment.getUTCDate = function (date) {
        return date.toISOString();
    };
    Moment.getUTC = function () {
        return this.getUTCDate(new Date());
    };
    /** Timezone **/
    /**
     * @param date
     * @return date, la date est au format UTC
     */
    Moment.getMyTimezoneDate = function (date) {
        var utcDate = this.getUTCDate(date);
        return new Date(utcDate);
    };
    Moment.getDateInMyTimezone = function () {
        return new Date();
    };
    /** Date is Available **/
    Moment.isInputDateAvailable = function () {
        var input = document.createElement('input');
        var value = 'a';
        input.setAttribute('type', 'date');
        input.setAttribute('value', value);
        return (input.value !== value);
    };
    /** Safari **/
    Moment.formatDateForSafari = function (date) {
        if (isNaN(new Date(date).getTime()) && (date.indexOf("T") === -1 && date.indexOf("Z") === -1)) {
            var tab = date.split("-");
            var newDate = "";
            for (var tIndex in tab) {
                newDate += tab[tIndex];
                if (parseInt(tIndex) < tab.length - 1) {
                    newDate += '/';
                }
            }
            return newDate;
        }
        else if (date.indexOf("T") !== -1 && date.indexOf("Z") === -1) {
            var tab = date.split("T");
            if (tab[1].length === 2) {
                return date + "00:00Z";
            }
            else {
                return date;
            }
        }
        else {
            return date;
        }
    };
    return Moment;
}());
export default Moment;
/** Date Prototype**/
if (typeof Date.prototype.fromNow === 'undefined') {
    Date.prototype.fromNow = function () {
        return Moment.getTimeFromNow(this);
    };
}
//# sourceMappingURL=Moment.js.map